import { createLucideIcon } from "lucide-react";

export const Api = createLucideIcon(
    "Api",
    [
        [
            "path",
            {
                d: "M12.5 12V15",
                key: "juov4u",
            },
        ],
        [
            "path",
            {
                d: "M12.5 12V9.7C12.5 9.5139 12.5 9.4208 12.5245 9.3455C12.5739 9.1933 12.6933 9.0739 12.8455 9.0245C12.9208 9 13.0139 9 13.2 9H14.5C15.3284 9 16 9.6716 16 10.5C16 11.3284 15.3284 12 14.5 12H12.5Z",
                key: "ihl94f",
            },
        ],
        [
            "path",
            {
                d: "M18.5 9V15",
                key: "4anm1a",
            },
        ],
        [
            "path",
            {
                d: "M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12Z",
                key: "1c3crg",
            },
        ],
        [
            "path",
            {
                d: "M6 13.5H9.375",
                key: "3l8b86",
            },
        ],
        [
            "path",
            {
                d: "M6 13.5L5.5 15",
                key: "1bgr67",
            },
        ],
        [
            "path",
            {
                d: "M6 13.5L7.5 9L9.375 13.5",
                key: "1rxgq0",
            },
        ],
        [
            "path",
            {
                d: "M9.375 13.5L10 15",
                key: "15sl4p",
            },
        ],
    ],
);
